export class AdminAction{
    displaytext: string;
    route?: string;
    params?: any = {};
    callback?: any;
    classes: any = ['fa', 'fa-bars'];
    disabled?: boolean = false;
    featureGroup?: number;
    isTableAction? = false;
    childrenActions?: AdminAction[];
}